import React from 'react';

import './App.css';
import './styles/game.scss';
import './styles/index.scss';
import { API } from '@pbl/pbl-react-core/lib/services';
import { addRequestTransform, addResponseTransform, apiConfiguration } from './utils/apiConfig';
import AppSpinner from './app-spinner/AppSpinner';

interface AppState {}

class App extends React.Component<{}, AppState> {
  componentDidMount() {
    API.setup(apiConfiguration, { addRequestTransform, addResponseTransform });
  }

  preventBubblingToElement(event) {
    event.stopPropagation();
    return false;
  }

  validateInput(event) {
    let key = event.keyCode || event.which;
    // Handle paste
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      // Handle key press
      key = String.fromCharCode(key);
    }
    const regex = /^[0-9]+$/;

    if (!regex.test(key) || event.target?.value?.length === 6 || key === 'e') {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
      return false;
    }
  }

  render() {
    return (
      <>
        <div id="otw-message-popup" className={'otw-input-popup'} onClick={this.preventBubblingToElement}>
          {/* <div className={'overlay'}>overlay</div> */}
          <div id="otw-message-container">
            <label id="otw-message-label" style={{ fontFamily: 'Jost' }} className={'otw-label'}>
              message
            </label>
          </div>

          <button className={'otw-message-btn'} type={'button'} id={'otw-message-submit'} />
        </div>
        <div id="otw-spinner">
          <AppSpinner />
        </div>
        <div id="otw-input-popup" className={'otw-input-popup'} style={{ fontFamily: 'Jost' }} onClick={this.preventBubblingToElement}>
          {/* <div className={'overlay'}>overlay</div> */}
          <div id="otw-draw-container">
            <label id="otw-label" style={{ fontFamily: 'Jost' }} className={'otw-label'}>
              DRAWING ID
            </label>
            <input
              type="number"
              className={'text-input'}
              id={'otw-input-draw-id'}
              max={999999}
              min={0}
              maxLength={6}
              name={'drawNumber'}
              autoComplete={'off'}
              onKeyPress={this.validateInput}
              onPaste={this.validateInput}
              style={{ fontFamily: 'Jost' }}
            />
          </div>
          <button className={'otw-popup-btn'} type={'button'} id={'otw-popup-submit'} />
        </div>
      </>
    );
  }
}

export default App;
